import React from "react";

import { professionalIcon } from "../../assets";
import * as S from "./styled";

const IndustryProfessional = () => {
  const handleAnalyticsLearnMoreClick = () => {
    window.dataLayer.push({
      event: "custom_event",
      event_category: "homepage",
      event_action: "industry_learn_more",
      event_label: "click"
    });
  };

  const handleSignIn = () => {
    window.gon.state.triggerScenario("EmailCapture");
    window.gon.state.analyticsData = { source: "homepage_industry" };
  };

  return (
    <S.IndustryProfessionalSection>
      <S.IndustryProfessionalContainer>
        <img alt="" src={professionalIcon} />
        <S.Title>Are you a real estate professional?</S.Title>
        <S.SubTitle>
          Sign in to access StreetEasy, or&nbsp;
          <S.Link
            href="/business/"
            onClick={() => handleAnalyticsLearnMoreClick()}
          >
            learn how we can help grow your business
          </S.Link>
          .
        </S.SubTitle>
        <S.SignInButton onClick={() => handleSignIn()}>Sign In</S.SignInButton>
      </S.IndustryProfessionalContainer>
    </S.IndustryProfessionalSection>
  );
};

export default IndustryProfessional;
